import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=19fc8af2&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "@/scss/login.scss?vue&type=style&index=0&id=19fc8af2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fc8af2",
  null
  
)

export default component.exports